import React, { useEffect, useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoadingScreen from '@/components/LoadingScreen';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import Stats from '@/components/Stats';
import Services from '@/components/Services';
import Process from '@/components/Process';
import Portfolio from '@/components/Portfolio';
import Industries from '@/components/Industries';
import Pricing from '@/components/Pricing';
import Testimonials from '@/components/Testimonials';
import Contact from '@/components/Contact';
import Roast from '@/components/Roast';
import Footer from '@/components/Footer';
import { prefersReducedMotion } from '@/lib/hooks';

function HomePage({ loading }) {
  return (
    <div className="App" style={{ visibility: loading ? 'hidden' : 'visible' }}>
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Process />
        <Portfolio />
        <Industries />
        <Pricing />
        <Testimonials />
        <Contact />
        <Roast />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  // Loader once per session
  const [loading, setLoading] = useState(() => {
    if (typeof window === 'undefined') return false;
    try { if (sessionStorage.getItem('sitehive_loaded')) return false; } catch (e) { /* noop */ }
    return true;
  });

  useEffect(() => {
    if (!loading) return;
    if (prefersReducedMotion()) {
      try { sessionStorage.setItem('sitehive_loaded', 'true'); } catch (e) { /* noop */ }
      const t = setTimeout(() => setLoading(false), 400);
      return () => clearTimeout(t);
    }
  }, [loading]);

  const handleComplete = () => {
    try { sessionStorage.setItem('sitehive_loaded', 'true'); } catch (e) { /* noop */ }
    setLoading(false);
  };

  return (
    <BrowserRouter>
      {loading && <LoadingScreen onComplete={handleComplete} duration={2400} />}
      <Routes>
        <Route path="/" element={<HomePage loading={loading} />} />
        <Route path="*" element={<HomePage loading={loading} />} />
      </Routes>
    </BrowserRouter>
  );
}
